import React from "react";

export const Stats = (props) => (
  <div id="stats">
    <div className="container">
      <div className="row">
        {props.data
          ? props.data.map((d, i) => (
              <div key={`${d.label}-${i}`} className="col-xs-6 col-md-3 stat-item">
                <span className="stat-value">{d.value}</span>
                <span className="stat-label">{d.label}</span>
              </div>
            ))
          : null}
      </div>
    </div>
  </div>
);
